module.exports = __webpack_public_path__ + "static/media/LK_Information_Light.e15502ee.svg";